import { getAuthenticatedApiClient } from '../api-client';
import { useMutation } from 'react-query';

const deleteEventCategory = (id: number) =>
  getAuthenticatedApiClient()
    .deleteEventCategory({ id })
    .then((res) => res.data);

export const useDeleteEventCategory = () => useMutation('delete-event-category', deleteEventCategory);
